<template>
	<page>
		<module>
			<view-list ref="view" selector :work-type="workType" :view-config="saasInfo.viewmanage" @load="loadSummary">
				<template #search>
					<m-search ref="search" :default-data="defaultSearchData">
                        <m-search-item label="商户信息" colspan="2">
                            <c-select name="saas_ids" multiple async @search="searchSaas"></c-select>
                        </m-search-item>
						<m-search-item label="订单号">
							<c-input name="order_no"></c-input>
						</m-search-item>
						<m-search-item label="背贴码">
							<m-code-batch-input name="produce_codes" field-name="背贴码"></m-code-batch-input>
						</m-search-item>
						<m-search-item label="IMEI">
							<m-code-batch-input name="imeis" field-name="IMEI"></m-code-batch-input>
						</m-search-item>
						<m-search-item label="支付单号">
							<c-input name="pay_trade_number"></c-input>
						</m-search-item>
						<m-search-item label="三方支付流水号">
							<c-input name="third_party_order_no"></c-input>
						</m-search-item>
						<m-search-item label="支付方式">
							<c-select name="pay_channel" :options="PAY_METHOD_OPTIONS"></c-select>
						</m-search-item>
<!--						<m-search-item label="核销状态">
							<c-select name="check_state" :options="CHECK_ORDER_STATUS"></c-select>
						</m-search-item>-->
						<!-- 支付时间：默认查询今日支付的订单 -->
						<m-search-item label="支付时间" colspan="2">
							<c-datetime range start-name="pay_start_date" end-name="pay_end_date"></c-datetime>
						</m-search-item>
					</m-search>

					<!-- 通联订单核销汇总统计 -->
					<div class="stats-bar flex">
						<div class="stats-card card-blue">
							<div class="stats-info">
								<div class="stats-title-row flex-start-center">
									<span class="stats-label">待核销商品数</span>
									<span class="stats-value">{{ formatNumber(summary.pending_count) }}</span>
								</div>
							</div>
							<div class="stats-icon"><i class="tf tf-phone"></i></div>
						</div>
						<div class="stats-card card-green">
							<div class="stats-info">
								<div class="stats-title-row flex-start-center">
									<span class="stats-label">待核销金额</span>
									<span class="stats-value">￥{{ formatMoney(summary.pending_amount) }}</span>
								</div>
							</div>
							<div class="stats-icon">¥</div>
						</div>
					</div>
				</template>

				<template #operate>
					<c-button v-if="auth('b_allinpay_order_check_audit')" color="main" :disabled="isSubmitting" @click="submitCheck(2)">生成核销单</c-button>
					<c-button v-if="auth('b_allinpay_order_check_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
				</template>

				<!-- 商品信息 -->
				<template #product_name="{data}">
					<m-product-info :name="getProductText(data)" :level="data.level_type" :code="data.produce_code" :imei="data.imei"></m-product-info>
				</template>
				<!-- 订单类型 -->
				<template #order_type="{data}">
					<c-state async tag dict="ORDER_TYPE" :value="data.order_type"></c-state>
				</template>
				<!-- 销售渠道 -->
				<template #channel_name="{data}">
					{{data.channel_name || '-'}}
				</template>
				<!-- 支付方式（通联） -->
				<template #pay_channel="{data}">
					{{PAY_METHOD_MAP[data.pay_channel] || data.pay_channel || '-'}}
				</template>

				<!-- 成本价 -->
				<template #cost_price="{data}">
					{{formatPrice(data.cost_price)}}
				</template>

				<!-- 销售价 -->
				<template #sale_price="{data}">
					<span style="color:green">{{formatPrice(data.sale_price)}}</span>
				</template>

				<!-- 售后金额 -->
				<template #refund_amount="{data}">
					<span v-if="data.refund_amount" style="color: red;">{{formatPrice(data.refund_amount)}}</span>
					<span v-else>-</span>
				</template>

				<!-- 手续费 -->
				<template #fee="{data}">
					<span v-if="data.fee && data.fee > 0" style="color: red;">{{formatPrice(data.fee)}}</span>
					<span v-else style="color: gray">{{formatPrice(0)}}</span>
				</template>

				<!-- 结算价 -->
				<template #settle_price="{data}">
					<span v-if="data.settle_price && data.settle_price > 0" style="color: green;">{{formatPrice(data.settle_price)}}</span>
					<span v-else style="color: gray">{{formatPrice(0)}}</span>
				</template>

				<!-- 核销状态 -->
				<template #check_state="{data}">
					<c-state async tag dict="CHECK_ORDER_STATUS" :value="data.check_state"></c-state>
				</template>

				<!-- 支付渠道 -->
				<template #check_payment_channel="{data}">
					<c-state async tag dict="CHECK_PAYMENT_CHANNEL" :value="data.check_payment_channel"></c-state>
				</template>

				<!-- 支付时间 -->
				<template #pay_date="{data}">
					{{data.pay_date || ''}}
				</template>

				<!-- 下单时间 -->
				<template #create_date="{data}">
					{{data.create_date || ''}}
				</template>

				<!-- 结算时间 -->
				<template #settle_date="{data}">
					{{data.settle_date || ''}}
				</template>
			</view-list>

			<!-- 结算金额确认弹窗：按商家汇总展示选中商品的结算金额，核对无误后确认提交核销 -->
			<c-dialog ref="settleDialog" title="结算金额确认" width="800">
				<div class="settle-summary-tip">
					<span class="tip-icon">!</span>
					<span class="tip-text">本次核销共选中 <b class="hl">{{selectedRows.length}}</b> 件商品，请核对各商家销售与售后金额，确认无误后提交：</span>
				</div>
				<c-table :data="settleList" border :paging="false">
					<c-table-column label="商家代码" width="90">
						<template #default="{data}">
							{{data.saas_id}}
						</template>
					</c-table-column>
					<c-table-column label="商家名称">
						<template #default="{data}">
							{{data.saas_name || '-'}}
						</template>
					</c-table-column>
					<c-table-column label="商品数量" width="80">
						<template #default="{data}">
							{{data.product_count}} 件
						</template>
					</c-table-column>
					<c-table-column label="销售总额（元）" width="110">
						<template #default="{data}">
							{{formatMoney(data.sale_total_amount)}}
						</template>
					</c-table-column>
					<c-table-column label="售后总额（元）" width="110">
						<template #default="{data}">
							<b v-if="parseFloat(data.refund_total_amount) > 0" class="price-green">-{{formatMoney(data.refund_total_amount)}}</b>
							<span v-else>{{formatMoney(data.refund_total_amount)}}</span>
						</template>
					</c-table-column>
					<c-table-column label="手续费（元）" width="120">
						<template #default="{data}">
                            <b v-if="parseFloat(data.fee) > 0" class="price-green">-{{formatMoney(data.fee)}}</b>
                            <span v-else>{{formatMoney(data.fee)}}</span>
						</template>
					</c-table-column>
					<c-table-column label="结算总额（元）" width="120">
						<template #default="{data}">
							<b class="price-red">￥{{formatMoney(data.total_amount)}}</b>
						</template>
					</c-table-column>
				</c-table>
				<div class="settle-summary-total">
					<span class="total-label">合计：{{settleTotalCount}} 件</span>
					<span class="total-item">销售总额 <b>￥{{formatMoney(settleSaleTotal)}}</b></span>
					<span class="total-item">售后总额 <b class="price-green">{{settleRefundTotal > 0 ? '-' : ''}}￥{{formatMoney(settleRefundTotal)}}</b></span>
					<span class="total-item">手续费 <b class="price-green">{{feeTotal > 0 ? '-' : ''}}￥{{formatMoney(feeTotal)}}</b></span>
					<span class="total-item">结算总额 <span class="amount">￥{{settleTotalAmount}}</span></span>
				</div>
				<template #foot>
					<span class="settle-summary-hint">确认后将按商家生成“待审核”核销单，审核通过后完成核销</span>
				</template>
				<template #button>
					<c-button color="main" size="dialog" :disabled="isSubmitting" @click="confirmSubmit">确认提交</c-button>
					<c-button size="dialog" :disabled="isSubmitting" @click="closeSettleDialog">取消</c-button>
				</template>
			</c-dialog>
		</module>
	</page>
</template>

<script>
import {mapState} from 'vuex'
import {asyncMapState} from '@/store'

//通联支付方式选项（TBL_ORDER_UNION_PAY.pay_channel，PayMethodEnum）
const PAY_METHOD_OPTIONS = [
	{name: '余额', value: 'balance'},
	{name: '银行转账', value: 'bankcard'},
	{name: '微信', value: 'wxpay'},
	{name: '微信扫码', value: 'wxpay_scan'},
	{name: '支付宝扫码', value: 'alipay_scan'}
];
const PAY_METHOD_MAP = {
	balance: '余额',
	bankcard: '银行转账',
	wxpay: '微信',
	wxpay_scan: '微信扫码',
	alipay_scan: '支付宝扫码'
};

export default {
	name: 'p_allinpay_order_check',

	data() {
		//日期格式化（yyyy-MM-dd）
		const pad = num => (num < 10 ? '0' + num : '' + num);
		const formatDate = date => `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
		const now = new Date();
        const defaultStartDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 7);   //默认开始时间：7天前

		return {
			workType: 129,
			//支付方式选项（通联）
			PAY_METHOD_OPTIONS: PAY_METHOD_OPTIONS,
			//支付时间默认值：默认查询今日支付的订单
			defaultSearchData: {
				pay_start_date: `${formatDate(defaultStartDate)} 00:00:00`,
				pay_end_date: `${formatDate(now)} 23:59:59`
			},
			summary: {},
			isSubmitting: false,//是否正在提交（防止重复提交）
			settleList: [],//商家结算金额汇总（确认弹窗表格数据）
			selectedRows: [],//选中行快照（打开确认弹窗时固定，提交以此为准）
			pendingStatus: 2//弹窗确认后提交的核销状态（通联渠道固定为2：待审核，审核通过后完成核销）
		}
	},

	computed: {
		...mapState(['saasInfo']),

		PAY_METHOD_MAP() {
			return PAY_METHOD_MAP;
		},

		...asyncMapState(['CHECK_ORDER_STATUS', 'ORDER_TYPE']),

		//确认弹窗汇总表：合计商品数
		settleTotalCount() {
			var total = 0;
			(this.settleList || []).forEach(item => {
				total += parseInt(item.product_count) || 0;
			});
			return total;
		},

		//确认弹窗汇总表：销售总额合计（按分累加避免浮点精度问题）
		settleSaleTotal() {
			var total = 0;
			(this.settleList || []).forEach(item => {
				total += Math.round((parseFloat(item.sale_total_amount) || 0) * 100);
			});
			return total / 100;
		},

		//确认弹窗汇总表：售后总额合计（按分累加避免浮点精度问题）
		settleRefundTotal() {
			var total = 0;
			(this.settleList || []).forEach(item => {
				total += Math.round((parseFloat(item.refund_total_amount) || 0) * 100);
			});
			return total / 100;
		},
		//确认弹窗汇总表：手续费合计（按分累加避免浮点精度问题）
		feeTotal() {
			var total = 0;
			(this.settleList || []).forEach(item => {
				total += Math.round((parseFloat(item.fee) || 0) * 100);
			});
			return total / 100;
		},

		//确认弹窗汇总表：合计结算金额（按分累加避免浮点精度问题）
		settleTotalAmount() {
			var total = 0;
			(this.settleList || []).forEach(item => {
				total += Math.round((parseFloat(item.total_amount) || 0) * 100);
			});
			return this.formatMoney(total / 100);
		}
	},

	methods: {
        /*******搜索商户*****************/
        searchSaas(keyword, resolve){
            this.request({
                url: '/sys_saas/options',
                data: {
                    keyword: keyword
                },
                success:data => {
                    resolve(data);
                }
            })
        },
		/*********获取产品信息文字（品牌+型号+颜色+内存拼接，缺失时回退 product_name）**********/
		getProductText(data) {
			var parts = [];
			if (data.brand_name) parts.push(data.brand_name);
			if (data.model_name) parts.push(data.model_name);
			if (data.color_name) parts.push(data.color_name);
			if (data.memory_name) parts.push(data.memory_name);
			return parts.join(' ') || data.product_name || '-';
		},

		/*********加载汇总统计（随列表查询条件联动）**********/
		loadSummary(listData, searchParams) {
			this.request({
				url: '/financial/allinpay/order/check/summary',
				data: searchParams || {},
				success: data => {
					this.summary = data || {};
				}
			});
		},

		/*********生成核销单：先调接口按商家汇总结算金额，弹窗确认后再提交（复用 /sale/check/add，通联支付渠道，生成待审核核销单）**********/
		submitCheck(status) {
			//防止重复提交：请求进行中直接忽略点击
			if (this.isSubmitting) return;
			//选中的订单商品行
			var selected = this.$refs.view.$refs.list.getData('selected') || [];
			if (!selected.length) {
				this.$message({
					message: '请选择需要核销的订单商品',
					type: 'warn'
				});
				return;
			}
			//已核销或已生成核销数据（含待核销核销单）的行不可重复提交
			var checkedList = selected.filter(item => item.check_order_id);
			if (checkedList.length > 0) {
				this.$message({
					message: '选中的数据中存在【' + checkedList.length + '】条已核销或已生成核销数据的订单商品，请勿重复提交',
					type: 'warn'
				});
				return;
			}
			//固定选中行快照与目标状态，汇总返回后打开确认弹窗，提交以快照为准
			this.selectedRows = selected;
			this.pendingStatus = status;
			//按商家汇总结算金额（后端聚合，确认弹窗表格展示）
			this.request({
				url: '/financial/allinpay/order/check/settle/summary',
				loading: true,
				data: {
					product_list: selected.map(item => {
						return {
							saas_id: item.saas_id,
							saas_name: item.saas_name,
							sale_price: item.sale_price,
                            fee: item.fee||0,
							refund_amount: item.refund_amount
						};
					})
				},
				success: data => {
					this.settleList = data || [];
					this.$refs.settleDialog.open();
				}
			});
		},

		/*********结算确认弹窗：确认提交**********/
		confirmSubmit() {
			//以打开弹窗时的选中行快照提交，避免弹窗期间列表变动导致汇总与提交不一致
			var selected = this.selectedRows.slice();
			var status = this.pendingStatus;
			this.$refs.settleDialog.close();
			this.doSubmitCheck(status, selected);
		},

		/*********结算确认弹窗：取消**********/
		closeSettleDialog() {
			this.$refs.settleDialog.close();
		},

		/*********执行提交**********/
		doSubmitCheck(status, selected) {
			//组装核销商品明细（金额单位：元，后端转分）
			var product_list = selected.map(item => {
				return {
					saas_id: item.saas_id,
					produce_unique_code_id: item.product_unique_code_id,
					order_id: item.order_id,
					order_product_id: item.id,
					platform_sale_price: item.sale_price,
					platform_return_money: item.platform_return_money||0,
					platform_supplement_money: item.platform_supplement_money||0,
					check_product_money: item.sale_price,
					check_return_money: item.platform_return_money||0,
					check_supplement_money: item.platform_supplement_money||0,
					out_order_number: item.order_no,
					third_number: item.third_party_order_no,
					receipt_date: (item.pay_date || '').substring(0, 10)
				};
			});
			this.isSubmitting = true;
			this.request({
				url: '/sale/check/add',
				//请求期间显示全屏遮罩，物理阻断重复点击
				loading: true,
				data: {
					status: status,
					//支付渠道：1-通联支付
					check_payment_channel: 1,
					product_list: product_list
				},
				success: data => {
					this.$message({
						message: status == 2 ? '核销单已生成，等待审核' : '数据保存成功',
						type: 'success'
					});
					//刷新列表（统计卡片随 @load 联动刷新）
					this.$refs.view.update();
				},
				//成功/业务失败后均会执行，重置提交状态
				complete: () => {
					this.isSubmitting = false;
				},
				//网络异常/超时时complete不会执行，此处兜底重置
				error: () => {
					this.isSubmitting = false;
				}
			});
		},

		/*********格式化价格**********/
		formatPrice(price) {
			if (price === null || price === undefined || price === '') return '-';
			return '¥' + parseFloat(price).toFixed(2);
		},

		/**
		 * 金额格式化（保留两位小数）
		 */
		formatMoney(val) {
			if (val === undefined || val === null || val === '') {
				return '0.00';
			}
			const num = parseFloat(val);
			return isNaN(num) ? '0.00' : num.toFixed(2);
		},

		/**
		 * 数量格式化
		 */
		formatNumber(val) {
			if (val === undefined || val === null || val === '') {
				return '0';
			}
			const num = parseFloat(val);
			return isNaN(num) ? '0' : String(Math.round(num));
		}
	}
}
</script>

<style lang="stylus" scoped>
.settle-summary-tip {
	display: flex;
	align-items: center;
	gap: 8px;
	margin-bottom: 12px;
	padding: 10px 12px;
	background: #f0f5ff;
	border: 1px solid #d6e4ff;
	border-radius: 6px;
	font-size: 13px;
	line-height: 20px;
	color: #333;

	.tip-icon {
		flex-shrink: 0;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: 18px;
		height: 18px;
		border-radius: 50%;
		background: #2563eb;
		color: #fff;
		font-size: 12px;
		font-weight: bold;
	}

	.hl {
		padding: 0 2px;
		color: #2563eb;
		font-weight: bold;
	}
}

.price-red {
	color: #e53e3e;
}

.price-green {
	color: #16a34a;
}

.settle-summary-total {
	display: flex;
	align-items: baseline;
	justify-content: flex-end;
	gap: 16px;
	margin-top: 12px;
	padding: 10px 12px;
	background: #f8fafc;
	border: 1px solid #f1f5f9;
	border-radius: 6px;
	font-size: 13px;

	.total-item {
		b {
			font-weight: bold;
		}
	}

	.amount {
		color: #e53e3e;
		font-size: 18px;
		font-weight: bold;
	}
}

.settle-summary-hint {
	font-size: 12px;
	color: #999;
}

.stats-bar {
    flex-shrink: 0;
    gap: 10px;
	border-top: 1px solid #F5F5F5;
	padding: 8px 12px;

    .stats-card {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex: 1;
        max-width: 360px;
        min-height: 56px;
        padding: 8px 16px;
        border-radius: 6px;
        color: #fff;
        box-sizing: border-box;
        overflow: hidden;

        &.card-blue {
            background: linear-gradient(90deg, #2563eb, #3b82f6);
        }

        &.card-green {
            background: linear-gradient(90deg, #16a34a, #22c55e);
        }

        .stats-info {
            position: relative;
            z-index: 1;

            .stats-title-row {
                display: flex;
                align-items: baseline;
                line-height: 24px;

                .stats-label {
                    font-size: 12px;
                    opacity: 0.95;
                }

                .stats-value {
                    margin-left: 6px;
                    font-size: 18px;
                    font-weight: bold;
                }
            }
        }

        .stats-icon {
            position: absolute;
            right: 14px;
            top: 50%;
            transform: translateY(-50%);
            font-size: 32px;
            line-height: 1;
            opacity: 0.15;

            .tf {
                font-size: 32px;
            }
        }
    }
}

.m-product-info {
	&-name {
		gap: 6px;

		span {
			font-size: 14px;
		}
	}

	&-attr {
		margin-top: 4px;
		font-size: 12px;
		color: #999;
	}
}
</style>
